import type { TFunction } from 'i18next';

export const SEARCH_TERM_MAX_LENGTH = 150;

export const SEARCH_TERM_CHAR_LIMIT_I18N_KEY = 'search.maxCharLimitReachedError';

export function isSearchTermOverCharLimit(value: string): boolean {
  return value.length >= SEARCH_TERM_MAX_LENGTH;
}

export function getSearchTermCharLimitHelperText(t: TFunction, value: string): string | null {
  if (!isSearchTermOverCharLimit(value)) {
    return null;
  }

  return t(SEARCH_TERM_CHAR_LIMIT_I18N_KEY, { chars: value.length });
}

export type SearchTermCharLimitFieldProps = {
  error: boolean;
  helperText: string | null;
};

export function getSearchTermCharLimitFieldProps(t: TFunction, value: string): SearchTermCharLimitFieldProps {
  const helperText = getSearchTermCharLimitHelperText(t, value);

  return {
    error: helperText !== null,
    helperText,
  };
}
